export default __webpack_public_path__ + "static/media/links.b202f57b.svg";